import i3bFramed from "./3b-framed.svg";
import i3bFrameless from "./3b-frameless.svg";
import i3bMark from "./3b-mark.svg";
import accent from "./accent.svg";
import activity from "./activity.svg";
import agentClose from "./agent-close.svg";
import agentOpen from "./agent-open.svg";
import alignVerticalSpaceAround from "./align-vertical-space-around.svg";
import apiKeyCustom from "./api-key-custom.svg";
import appIcon from "./app-icon.svg";
import appWindow from "./app-window.svg";
import appsEmpty from "./apps-empty.svg";
import arrowDown from "./arrow-down.svg";
import arrowDownAZ from "./arrow-down-a-z.svg";
import arrowDownUp from "./arrow-down-up.svg";
import arrowLeft from "./arrow-left.svg";
import arrowRight from "./arrow-right.svg";
import arrowUp from "./arrow-up.svg";
import arrowUpDown from "./arrow-up-down.svg";
import arrowUpRight from "./arrow-up-right.svg";
import ask from "./ask.svg";
import askFilled from "./ask-filled.svg";
import atSign from "./at-sign.svg";
import audioLines from "./audio-lines.svg";
import audioWaveform from "./audio-waveform.svg";
import award from "./award.svg";
import bell from "./bell.svg";
import bellOff from "./bell-off.svg";
import bird from "./bird.svg";
import bold from "./bold.svg";
import book from "./book.svg";
import bookmark from "./bookmark.svg";
import bot from "./bot.svg";
import box from "./box.svg";
import brain from "./brain.svg";
import brushCleaning from "./brush-cleaning.svg";
import bug from "./bug.svg";
import building2 from "./building-2.svg";
import calendar from "./calendar.svg";
import camera from "./camera.svg";
import caseSensitive from "./case-sensitive.svg";
import chartNoAxesColumn from "./chart-no-axes-column.svg";
import check from "./check.svg";
import checkEmpty from "./check-empty.svg";
import checkFilled from "./check-filled.svg";
import chevronDown from "./chevron-down.svg";
import chevronLeft from "./chevron-left.svg";
import chevronRight from "./chevron-right.svg";
import chevronUp from "./chevron-up.svg";
import circleArrowDown from "./circle-arrow-down.svg";
import circleDashed from "./circle-dashed.svg";
import circleMinus from "./circle-minus.svg";
import circleOff from "./circle-off.svg";
import circlePause from "./circle-pause.svg";
import circleSlash from "./circle-slash.svg";
import circleUserRound from "./circle-user-round.svg";
import clock from "./clock.svg";
import code from "./code.svg";
import cog from "./cog.svg";
import command from "./command.svg";
import component from "./component.svg";
import cone from "./cone.svg";
import copy from "./copy.svg";
import cornerDownLeft from "./corner-down-left.svg";
import crown from "./crown.svg";
import database from "./database.svg";
import dices from "./dices.svg";
import diffs from "./diffs.svg";
import discoverableSpace from "./discoverable-space.svg";
import earth from "./earth.svg";
import eclipse from "./eclipse.svg";
import effort from "./effort.svg";
import expand from "./expand.svg";
import eye from "./eye.svg";
import eyeClosed from "./eye-closed.svg";
import fastForward from "./fast-forward.svg";
import fileBracesCorner from "./file-braces-corner.svg";
import fileScan from "./file-scan.svg";
import fileSymlink from "./file-symlink.svg";
import fingerprintPattern from "./fingerprint-pattern.svg";
import fireExtinguisher from "./fire-extinguisher.svg";
import flame from "./flame.svg";
import folder from "./folder.svg";
import frown from "./frown.svg";
import galleryVerticalEnd from "./gallery-vertical-end.svg";
import gift from "./gift.svg";
import gitBranch from "./git-branch.svg";
import graduationCap from "./graduation-cap.svg";
import handCoins from "./hand-coins.svg";
import hash from "./hash.svg";
import headset from "./headset.svg";
import heart from "./heart.svg";
import heartCrack from "./heart-crack.svg";
import heartHandshake from "./heart-handshake.svg";
import history from "./history.svg";
import house from "./house.svg";
import idCard from "./id-card.svg";
import idCardLanyard from "./id-card-lanyard.svg";
import imagePlus from "./image-plus.svg";
import info from "./info.svg";
import input from "./input.svg";
import italic from "./italic.svg";
import joystick from "./joystick.svg";
import key from "./key.svg";
import keyboard from "./keyboard.svg";
import laptop from "./laptop.svg";
import layers from "./layers.svg";
import layout from "./layout.svg";
import link2 from "./link-2.svg";
import list from "./list.svg";
import listFilter from "./list-filter.svg";
import listOrdered from "./list-ordered.svg";
import listTodo from "./list-todo.svg";
import lock from "./lock.svg";
import lockFilled from "./lock-filled.svg";
import logIn from "./log-in.svg";
import logOut from "./log-out.svg";
import logs from "./logs.svg";
import maximize2 from "./maximize-2.svg";
import megaphone from "./megaphone.svg";
import merge from "./merge.svg";
import messageCircle from "./message-circle.svg";
import messageCircleQuestionMark from "./message-circle-question-mark.svg";
import mic from "./mic.svg";
import minimize2 from "./minimize-2.svg";
import minus from "./minus.svg";
import monitorSmartphone from "./monitor-smartphone.svg";
import moon from "./moon.svg";
import more from "./more.svg";
import mousePointer2 from "./mouse-pointer-2.svg";
import newspaper from "./newspaper.svg";
import notebookTabs from "./notebook-tabs.svg";
import notebookText from "./notebook-text.svg";
import orbit from "./orbit.svg";
import output from "./output.svg";
import package2 from "./package-2.svg";
import paintbrushVertical from "./paintbrush-vertical.svg";
import palette from "./palette.svg";
import panelLeftOpen from "./panel-left-open.svg";
import panelRightOpen from "./panel-right-open.svg";
import panels from "./panels.svg";
import paperclip from "./paperclip.svg";
import pause from "./pause.svg";
import pencil from "./pencil.svg";
import pin from "./pin.svg";
import pinFilled from "./pin-filled.svg";
import play from "./play.svg";
import plug from "./plug.svg";
import plus from "./plus.svg";
import productCases from "./product-cases.svg";
import productDashboards from "./product-dashboards.svg";
import productRecords from "./product-records.svg";
import productWorkflows from "./product-workflows.svg";
import puzzle from "./puzzle.svg";
import rabbit from "./rabbit.svg";
import radar from "./radar.svg";
import rat from "./rat.svg";
import receiptText from "./receipt-text.svg";
import redo2 from "./redo-2.svg";
import refreshCcw from "./refresh-ccw.svg";
import regex from "./regex.svg";
import rocket from "./rocket.svg";
import rotateCcw from "./rotate-ccw.svg";
import rotateCw from "./rotate-cw.svg";
import rulerDimensionLine from "./ruler-dimension-line.svg";
import run from "./run.svg";
import runs from "./runs.svg";
import save from "./save.svg";
import scan from "./scan.svg";
import scanHeart from "./scan-heart.svg";
import search from "./search.svg";
import sendHorizontal from "./send-horizontal.svg";
import settings2 from "./settings-2.svg";
import shieldCheck from "./shield-check.svg";
import shieldHalf from "./shield-half.svg";
import shrink from "./shrink.svg";
import sideNav from "./side-nav.svg";
import skills from "./skills.svg";
import slash from "./slash.svg";
import slashCommand from "./slash-command.svg";
import smartphone from "./smartphone.svg";
import snail from "./snail.svg";
import soloRun from "./solo-run.svg";
import sparkles from "./sparkles.svg";
import sprout from "./sprout.svg";
import squareCode from "./square-code.svg";
import squarePen from "./square-pen.svg";
import squirrel from "./squirrel.svg";
import stamp from "./stamp.svg";
import star from "./star.svg";
import stickyNote from "./sticky-note.svg";
import stop from "./stop.svg";
import store from "./store.svg";
import strikethrough from "./strikethrough.svg";
import sun from "./sun.svg";
import sunMoon from "./sun-moon.svg";
import table from "./table.svg";
import tablet from "./tablet.svg";
import textQuote from "./text-quote.svg";
import textSearch from "./text-search.svg";
import thumbsDown from "./thumbs-down.svg";
import thumbsUp from "./thumbs-up.svg";
import ticket from "./ticket.svg";
import tinesMark from "./tines-mark.svg";
import toolCase from "./tool-case.svg";
import toolbox from "./toolbox.svg";
import towerControl from "./tower-control.svg";
import toyBrick from "./toy-brick.svg";
import trafficCone from "./traffic-cone.svg";
import trash from "./trash.svg";
import trigger from "./trigger.svg";
import trophy from "./trophy.svg";
import undo2 from "./undo-2.svg";
import upload from "./upload.svg";
import userRoundCheck from "./user-round-check.svg";
import userRoundPlus from "./user-round-plus.svg";
import usersRound from "./users-round.svg";
import volume2 from "./volume-2.svg";
import volumeOff from "./volume-off.svg";
import wallet from "./wallet.svg";
import wholeWord from "./whole-word.svg";
import workflowEmpty from "./workflow-empty.svg";
import x from "./x.svg";

export const icons = {
  "3b-framed": i3bFramed,
  "3b-frameless": i3bFrameless,
  "3b-mark": i3bMark,
  accent: accent,
  activity: activity,
  "agent-close": agentClose,
  "agent-open": agentOpen,
  "align-vertical-space-around": alignVerticalSpaceAround,
  "api-key-custom": apiKeyCustom,
  "app-icon": appIcon,
  "app-window": appWindow,
  "apps-empty": appsEmpty,
  "arrow-down": arrowDown,
  "arrow-down-a-z": arrowDownAZ,
  "arrow-down-up": arrowDownUp,
  "arrow-left": arrowLeft,
  "arrow-right": arrowRight,
  "arrow-up": arrowUp,
  "arrow-up-down": arrowUpDown,
  "arrow-up-right": arrowUpRight,
  ask: ask,
  "ask-filled": askFilled,
  "at-sign": atSign,
  "audio-lines": audioLines,
  "audio-waveform": audioWaveform,
  award: award,
  bell: bell,
  "bell-off": bellOff,
  bird: bird,
  bold: bold,
  book: book,
  bookmark: bookmark,
  bot: bot,
  box: box,
  brain: brain,
  "brush-cleaning": brushCleaning,
  bug: bug,
  "building-2": building2,
  calendar: calendar,
  camera: camera,
  "case-sensitive": caseSensitive,
  "chart-no-axes-column": chartNoAxesColumn,
  check: check,
  "check-empty": checkEmpty,
  "check-filled": checkFilled,
  "chevron-down": chevronDown,
  "chevron-left": chevronLeft,
  "chevron-right": chevronRight,
  "chevron-up": chevronUp,
  "circle-arrow-down": circleArrowDown,
  "circle-dashed": circleDashed,
  "circle-minus": circleMinus,
  "circle-off": circleOff,
  "circle-pause": circlePause,
  "circle-slash": circleSlash,
  "circle-user-round": circleUserRound,
  clock: clock,
  code: code,
  cog: cog,
  command: command,
  component: component,
  cone: cone,
  copy: copy,
  "corner-down-left": cornerDownLeft,
  crown: crown,
  database: database,
  dices: dices,
  diffs: diffs,
  "discoverable-space": discoverableSpace,
  earth: earth,
  eclipse: eclipse,
  effort: effort,
  expand: expand,
  eye: eye,
  "eye-closed": eyeClosed,
  "fast-forward": fastForward,
  "file-braces-corner": fileBracesCorner,
  "file-scan": fileScan,
  "file-symlink": fileSymlink,
  "fingerprint-pattern": fingerprintPattern,
  "fire-extinguisher": fireExtinguisher,
  flame: flame,
  folder: folder,
  frown: frown,
  "gallery-vertical-end": galleryVerticalEnd,
  gift: gift,
  "git-branch": gitBranch,
  "graduation-cap": graduationCap,
  "hand-coins": handCoins,
  hash: hash,
  headset: headset,
  heart: heart,
  "heart-crack": heartCrack,
  "heart-handshake": heartHandshake,
  history: history,
  house: house,
  "id-card": idCard,
  "id-card-lanyard": idCardLanyard,
  "image-plus": imagePlus,
  info: info,
  input: input,
  italic: italic,
  joystick: joystick,
  key: key,
  keyboard: keyboard,
  laptop: laptop,
  layers: layers,
  layout: layout,
  "link-2": link2,
  list: list,
  "list-filter": listFilter,
  "list-ordered": listOrdered,
  "list-todo": listTodo,
  lock: lock,
  "lock-filled": lockFilled,
  "log-in": logIn,
  "log-out": logOut,
  logs: logs,
  "maximize-2": maximize2,
  megaphone: megaphone,
  merge: merge,
  "message-circle": messageCircle,
  "message-circle-question-mark": messageCircleQuestionMark,
  mic: mic,
  "minimize-2": minimize2,
  minus: minus,
  "monitor-smartphone": monitorSmartphone,
  moon: moon,
  more: more,
  "mouse-pointer-2": mousePointer2,
  newspaper: newspaper,
  "notebook-tabs": notebookTabs,
  "notebook-text": notebookText,
  orbit: orbit,
  output: output,
  "package-2": package2,
  "paintbrush-vertical": paintbrushVertical,
  palette: palette,
  "panel-left-open": panelLeftOpen,
  "panel-right-open": panelRightOpen,
  panels: panels,
  paperclip: paperclip,
  pause: pause,
  pencil: pencil,
  pin: pin,
  "pin-filled": pinFilled,
  play: play,
  plug: plug,
  plus: plus,
  "product-cases": productCases,
  "product-dashboards": productDashboards,
  "product-records": productRecords,
  "product-workflows": productWorkflows,
  puzzle: puzzle,
  rabbit: rabbit,
  radar: radar,
  rat: rat,
  "receipt-text": receiptText,
  "redo-2": redo2,
  "refresh-ccw": refreshCcw,
  regex: regex,
  rocket: rocket,
  "rotate-ccw": rotateCcw,
  "rotate-cw": rotateCw,
  "ruler-dimension-line": rulerDimensionLine,
  run: run,
  runs: runs,
  save: save,
  scan: scan,
  "scan-heart": scanHeart,
  search: search,
  "send-horizontal": sendHorizontal,
  "settings-2": settings2,
  "shield-check": shieldCheck,
  "shield-half": shieldHalf,
  shrink: shrink,
  "side-nav": sideNav,
  skills: skills,
  slash: slash,
  "slash-command": slashCommand,
  smartphone: smartphone,
  snail: snail,
  "solo-run": soloRun,
  sparkles: sparkles,
  sprout: sprout,
  "square-code": squareCode,
  "square-pen": squarePen,
  squirrel: squirrel,
  stamp: stamp,
  star: star,
  "sticky-note": stickyNote,
  stop: stop,
  store: store,
  strikethrough: strikethrough,
  sun: sun,
  "sun-moon": sunMoon,
  table: table,
  tablet: tablet,
  "text-quote": textQuote,
  "text-search": textSearch,
  "thumbs-down": thumbsDown,
  "thumbs-up": thumbsUp,
  ticket: ticket,
  "tines-mark": tinesMark,
  "tool-case": toolCase,
  toolbox: toolbox,
  "tower-control": towerControl,
  "toy-brick": toyBrick,
  "traffic-cone": trafficCone,
  trash: trash,
  trigger: trigger,
  trophy: trophy,
  "undo-2": undo2,
  upload: upload,
  "user-round-check": userRoundCheck,
  "user-round-plus": userRoundPlus,
  "users-round": usersRound,
  "volume-2": volume2,
  "volume-off": volumeOff,
  wallet: wallet,
  "whole-word": wholeWord,
  "workflow-empty": workflowEmpty,
  x: x,
} as const;

export type IconName = keyof typeof icons;
